import {useState} from 'react';
import useLogic from '../../hooks/useLogic';
import mapStateToProps from '../../redux/mapStateToProps';
import mapDispatchToProps from '../../redux/mapDispatchToProps';
import { connect } from 'react-redux';
import Display from '../Display';
import Numbers from '../Numbers';
import Operations from '../Operations';
import Functions from '../Functions';
import './Calculator.css';

const Calculator = ({ stateProps, dispatchProps }) => {
  const [ screen, setScreen ] = useState("");
  const [ firstNumber, setFirstNumber ] = useState("");
  const [ secondNumber, setSecondNumber ] = useState("");
  const { history } = stateProps;
  const { onClickOperation, onClickNumber, onClickClear, onClickDelete,
    onClickEqual } = useLogic(stateProps, dispatchProps, screen, setScreen, 
      firstNumber, setFirstNumber, secondNumber, setSecondNumber);

  return(
    <div className="calculator" data-testid="calculator">
        <Display 
          valueMain={(screen && screen) || "0"} 
          valueHistory={history && history}
          />
      <Numbers onClickNumber={ text => onClickNumber(text) }/>
      <Operations onClickOperation={ text => onClickOperation(text) }/>
      <Functions 
        onClickClear={()=> onClickClear()}
        onClickDelete={()=> onClickDelete()}
        onClickEqual={()=> onClickEqual()}
      />
    </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Calculator);